import { render, staticRenderFns } from "./TableActionButtons.vue?vue&type=template&id=891596b0&"
import script from "./TableActionButtons.vue?vue&type=script&lang=js&"
export * from "./TableActionButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports